import { createTheme  } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#222222',
    },
    secondary: {
      main: '#666666',
    },
  },
  shape: {
    borderRadius: 25,
  },
});